import React, { useState, useEffect } from 'react'
import { string, func, bool, arrayOf, shape, oneOfType } from 'prop-types'
import Arrow from './assets/arrow.svg'

const SelectBox = ({
  className,
  onChange,
  selected,
  label,
  value,
  dropDownOptions,
  containerStyle,
  defaultValue,
  billToDropDown,
  addNewOption,
  id,
  hideLabel,
  validation,
  error,
  ariaLabel,
}) => {
  const [errorMsg, setErrorMsg] = useState('')
  const onBlur = () => {
    /* istanbul ignore else */
    if (typeof validation === 'function') setErrorMsg(validation(value))
  }
  useEffect(() => {
    setErrorMsg('')
  }, [value])
  useEffect(() => {
    setErrorMsg(error)
  }, [error])
  return (
    <div
      className={containerStyle ? `${containerStyle} select-box` : 'select-box'}
      aria-hidden={hideLabel}
    >
      {label ? <label htmlFor={id}>{label}</label> : null}
      <span className={`select-arrow ${!label ? 'no-label' : ''}`} data-testid='span'>
        <img src={Arrow} alt="▼" />
      </span>
      <select
        className={errorMsg ? `${className} error` : className}
        onChange={onChange}
        selected={selected}
        value={value}
        id={id}
        onBlur={onBlur}
        {...(!label && ariaLabel ? { 'aria-label': ariaLabel } : {})}
      >
        {defaultValue ? <option default>{defaultValue}</option> : null}
        <Options
          dropDownOptions={dropDownOptions}
          billToDropDown={billToDropDown}
          defaultValue={defaultValue}
        />
        {addNewOption ? <option>Add a new {addNewOption} </option> : null}
      </select>
      { errorMsg ? <div className="input-error" role="alert">{ errorMsg }</div> : null }
    </div>
  )
}

const Options = ({ dropDownOptions, billToDropDown, defaultValue }) => {
  const dropDownOption = dropDownOptions || []
  return dropDownOption.map((option, index) => {
    if (defaultValue !== option) {
      return (
        <option
          key={option}
          data-id={billToDropDown ? option[1] : index}
          value={billToDropDown ? option[0] : option}
        >
          {billToDropDown ? option[0] : option}
        </option>
      )
    }
    return null
  })
}

SelectBox.propTypes = {
  className: string,
  onChange: func.isRequired,
  validation: func,
  selected: bool,
  label: string,
  value: oneOfType([string, shape({})]),
  dropDownOptions: arrayOf(oneOfType([string, arrayOf(string)])),
  containerStyle: string,
  defaultValue: string,
  billToDropDown: bool,
  addNewOption: string,
  id: string,
  hideLabel: bool,
  error: string,
  ariaLabel: string,
}

SelectBox.defaultProps = {
  className: '',
  validation: null,
  selected: false,
  label: '',
  value: '',
  dropDownOptions: [],
  containerStyle: '',
  defaultValue: 'Choose...',
  billToDropDown: false,
  addNewOption: '',
  hideLabel: false,
  id: null,
  error: '',
  ariaLabel: '',
}

export default SelectBox
